<div class="flex flex-col space-y-4 items-center w-full rounded-lg bg-light-blue p-6">
  <div class="bg-dark-blue rounded-full p-3">
    <lucide-icon class="w-6 h-6 text-white" [name]="thumbsUp" />
  </div>

  <div class="flex flex-col space-y-1">
    <p class="text-sm font-semibold text-text-secondary text-center">OUR RECOMMENDATION</p>
    <h3 class="text-2xl font-semibold text-center">
      {{ recommendation() }}
    </h3>
  </div>
  <div class="text-center max-w-4xl mx-auto space-y-4">
    <p>
      We are fully committed to being part of the solution for a better tomorrow. Our sustainability efforts are a
      central part in this ambition. Therefore, we recommend
      <span class="font-semibold">{{ recommendation() }}</span> for your needs.
    </p>
    <p>
      We work together, your Scope 1 & 2 emissions are our Scope 3! Emissions in this report are calculated as they
      would occur in your operations: Scope 1 & 2. Abacus turns data into real impact, we guide you toward smarter, more
      energy-efficient decisions with confidence.
    </p>
  </div>
</div>
